import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = m[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/oauth/session", { session_id: sessionId });
        // also keep session_token as bearer for cross-domain cookie reliability
        if (data?.session_token) localStorage.setItem("orixa_token", data.session_token);
        await refresh();
        window.location.hash = "";
        navigate("/dashboard", { replace: true });
      } catch (e) {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen grid place-items-center bg-background" data-testid="auth-callback">
      <div className="text-overline text-muted-foreground">Completing sign-in…</div>
    </div>
  );
}
